import * as React from 'react';
import { connect } from 'react-redux';
const find = require('lodash.find');

import { IMainPage } from '../../models/mainpage';
import { IDomain } from '../../redux/modules/domain/domain';
import { IRegionsData } from '../../models/regions_data';
import {
  NewBuildingCaption as Caption,
} from '../../components/new_building_caption/new_building_caption';

interface IProps {
  regionsData: IRegionsData;
  domain: IDomain;
  section: string;
}

interface ICapProps {
  section: string;
}

interface IState {
  shown: boolean;
}

class NewBuildingCaption extends React.Component<IProps, IState> {
  public constructor(props: IProps) {
    super(props);

    this.state = { shown: true };
  }

  public render() {
    if (this.captionShown()) {
      return (
        <Caption
            onClose={() => this.setState({shown: false})}
            regionDomain={this.props.domain.domain}
            regionName={this.props.regionsData.subdomainRegionInflectedTitle}
            availableRegions={this.props.regionsData.regions}/>);
    } else {
      return (<div/>);
    }
  }

  private captionShown() {
    if ((this.props.section === 'new-buildings') && (this.state.shown)) {
      const geoID = this.props.regionsData.subdomainRegionId;
      return !find(this.props.regionsData.regions, ['id', geoID]);
    } else {
      return false;
    }
  }
}

const CaptionWrapper = connect((
    state: {mainpage: IMainPage, domain: IDomain },
    props: ICapProps) => ({
  regionsData: state.mainpage.regionsData,
  domain: state.domain,
  section: props.section,
}))(NewBuildingCaption);

export { CaptionWrapper as NewBuildingCaption };
